/** Clones a visual slab; an ordinary emptied source must not carry its departed stack. */
export function createExtractionClone(field: HTMLElement, carryStack: boolean): HTMLElement {
  const clone = field.cloneNode(true) as HTMLElement;
  if (!carryStack) clone.querySelector(".game-board__stack")?.remove();
  return clone;
}
